import { Component, OnInit, OnChanges, OnDestroy, Input, EventEmitter, Output } from "@angular/core";
import { PatientAttachment } from "app/core/models/patient-attachment.model";

@Component({
  selector: 'app-patient-document-content-processing-warning',
  templateUrl: './patient-document-content-processing-warning.component.html',
  styleUrls: ['./patient-document-content-processing-warning.component.scss'],
  standalone: false
})
export class PatientDocumentContentProcessingWarningComponent {
  @Input() patientAttachment: PatientAttachment;
  @Input() requiresRefresh: boolean = false;
  @Input() refreshing: boolean = false;

  @Output() refreshClick = new EventEmitter<void>();

  onRefreshClick() {
    this.refreshClick.emit();
  }
}
